import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router/router'

Vue.use(Vuex);
var mobile = document.documentElement.clientWidth < 640;

export default new Vuex.Store({
  state: {
    infoPanelDeployed: mobile ? false : true,
    hoverFirstState: true,
    searchBar: true,
    iframe: false,
    sharing: false,
    activeNavbarItem: 'status',
    map: null,
    geocoder: null,
    language: { lang: 'en', name: "English" },
    activeIgo: null,
    mobile,
    treaty: "moratorium",
    ecpmActionsLayer: true,

    moreInfoStatus: true,
    moreInfoTreaty: mobile ? true : false,

    abolitionistLayer: true,
    commonRightAbolitionistLayer: true,
    moratoireLayer: true,
    retentionistLayer: true,

    moratoriumInFavourLayer: false,
    moratoriumAgainstLayer: false,
    moratoriumAbstentionLayer: false,
    moratoriumAbsenceLayer: false,

    op2RatifiedLayer: false,
    op2NotRatifiedLayer: false,

    activeCountry: null,
    hoveredPlace: null,
    fullscreen: false,

    responsiveMenu: false,

    fullPath: window.location.href
  },
  mutations: {
    updateMap (state, map) {
      state.map = map
    },
    updateGeocoder (state, geocoder) {
      state.geocoder = geocoder
    },
    updateFullPath (state, fullPath) {
      state.fullPath = fullPath
    },
    updateEcpmLayer (state, ecpmActionsLayerGeo) {
      state.ecpmActionsLayerGeo = ecpmActionsLayerGeo
    },
    updateMoreInfoTreaty (state) {
      state.moreInfoTreaty = true
    },
    updateMoreInfoStatus (state) {
      state.moreInfoStatus = true
    },
    updateHoverFirstState (state) {
      state.hoverFirstState = false
    },
    updateActiveNavbarItem (state, activeNavbarItem) {
      state.activeNavbarItem = activeNavbarItem
      updatePath({map: activeNavbarItem})

      let showStatusLayers = activeNavbarItem === "status"
      state.abolitionistLayer = showStatusLayers;
      state.moratoireLayer = showStatusLayers;
      state.retentionistLayer = showStatusLayers;
      state.commonRightAbolitionistLayer = showStatusLayers;

      let showTreatyLayers = activeNavbarItem === "treaty"
      let showOp2Layers = state.treaty === "op2"
      let showMoratoriumLayers = state.treaty === "moratorium"
      state.moratoriumInFavourLayer = showTreatyLayers && showMoratoriumLayers;
      state.moratoriumAgainstLayer = showTreatyLayers && showMoratoriumLayers;
      state.moratoriumAbstentionLayer = showTreatyLayers && showMoratoriumLayers;
      state.moratoriumAbsenceLayer = showTreatyLayers && showMoratoriumLayers;
      state.op2RatifiedLayer = showTreatyLayers && showOp2Layers;
      state.op2NotRatifiedLayer = showTreatyLayers && showOp2Layers;
    },

    updateTreaty (state, treaty) {
      state.treaty = treaty
      updatePath({treaty})
      let showOp2Layers = state.treaty === "op2"
      let showMoratoriumLayers = state.treaty === "moratorium"
      state.moratoriumInFavourLayer = showMoratoriumLayers;
      state.moratoriumAgainstLayer = showMoratoriumLayers;
      state.moratoriumAbstentionLayer = showMoratoriumLayers;
      state.moratoriumAbsenceLayer = showMoratoriumLayers;

      state.op2RatifiedLayer = showOp2Layers;
      state.op2NotRatifiedLayer = showOp2Layers;
    },

    toggleMoratoriumInFavourLayer (state, value = !state.moratoriumInFavourLayer) {
      state.moratoriumInFavourLayer = value
    },
    toggleMoratoriumAgainstLayer (state, value = !state.moratoriumAgainstLayer) {
      state.moratoriumAgainstLayer = value
    },
    toggleMoratoriumAbstentionLayer (state, value = !state.moratoriumAbstentionLayer) {
      state.moratoriumAbstentionLayer = value
    },
    toggleMoratoriumAbsenceLayer (state, value = !state.moratoriumAbsenceLayer) {
      state.moratoriumAbsenceLayer = value
    },

    toggleOp2RatifiedLayer (state, value = !state.op2RatifiedLayer) {
      state.op2RatifiedLayer = value
    },
    toggleOp2NotRatifiedLayer (state, value = !state.op2NotRatifiedLayer) {
      state.op2NotRatifiedLayer = value
    },

    toggleEcpmActionsLayer (state) {
      state.ecpmActionsLayer = !state.ecpmActionsLayer
    },
    toggleCommonRightAbolitionistLayer (state, value = !state.commonRightAbolitionistLayer) {
      state.commonRightAbolitionistLayer = value
    },
    toggleAbolitionistLayer (state, value = !state.abolitionistLayer) {
      state.abolitionistLayer = value
    },
    toggleMoratoireLayer (state, value = !state.moratoireLayer) {
      state.moratoireLayer = value
    },
    toggleRetentionistLayer (state, value = !state.retentionistLayer) {
      state.retentionistLayer = value
    },
    toggleFullscreen (state) {
      state.fullscreen = !state.fullscreen
    },
    updateLang (state, language) {
      state.language = language
      updatePath({lang: language.lang})
      document.documentElement.lang = state.language.lang;
    },
    updateActiveIGO (state, igoId) {
      state.activeIgo = igoId === state.activeIgo ? null : igoId
      updatePath({igo: state.activeIgo})
    },
    updateActiveCountry (state, iso) {
      state.activeCountry = iso
      updatePath({place: iso})
    },
    updateHoveredPlace (state, iso) {
      state.hoveredPlace = iso
    },
    toggleInfoPanel (state, value = !state.infoPanelDeployed) {
      state.infoPanelDeployed = value
    },
    toggleIframe (state, value = !state.iframe) {
      state.iframe = value
    },
    toggleSharing (state, value = !state.sharing) {
      state.sharing = value
    },
    toggleSearchBar (state, value = !state.searchBar) {
      state.searchBar = value
    },
    toggleResponsiveMenu (state, value = !state.responsiveMenu) {
      state.responsiveMenu = value
    }
  }
});

function updatePath (newParams) {
  let params = Object.fromEntries(new URLSearchParams(location.search));
  if ('map' in newParams) delete params['treaty'];
  if ('place' in newParams && newParams['place'] == null) { delete params['place']; delete newParams['place']; }
  if ('igo' in newParams && newParams['igo'] == null) { delete params['igo']; delete newParams['igo']; }
  router.push({ name: "main", query: Object.assign({}, params, newParams) })
}